<template>
  <v-snackbar
    v-model="visible"
    :bottom="snackbar.y === 'bottom'"
    :left="snackbar.x === 'left'"
    :multi-line="snackbar.mode === 'multi-line'"
    :right="snackbar.x === 'right'"
    :timeout="snackbar.timeout"
    :top="snackbar.y === 'top'"
    :vertical="snackbar.mode === 'vertical'"
    :color="snackbar.color"
    >{{ snackbar.text }}</v-snackbar
  >
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'iDS-SnackBar',
  data: function () {
    return {}
  },
  computed: {
    snackbar() {
      return this.getSnackBar()
    },
    visible: {
      get() {
        return this.snackbar.visible
      },
      set(value) {
        this.$store.commit('app/setSnackBar', { value: { visible: value } })
      }
    }
  },
  methods: {
    ...mapGetters('app', ['getSnackBar']),
  },
  mounted: function () {},
}
</script>


<style>
</style>